/** Strip trailing slash from a configured base URL. */
function normalizeBaseUrl(url: string | undefined): string {
  if (!url) return "";
  return url.replace(/\/$/, "");
}

/**
 * Contract-review API base URL.
 * Empty in Vite dev (proxied to the local Elysia server).
 */
export const API_BASE = import.meta.env.DEV
  ? ""
  : normalizeBaseUrl(import.meta.env.VITE_API_URL);

/**
 * Better Auth service base URL.
 * Empty in Vite dev (proxied to the auth service).
 */
export const AUTH_BASE =
  typeof window !== "undefined"
    ? import.meta.env.DEV
      ? ""
      : normalizeBaseUrl(import.meta.env.VITE_AUTH_URL)
    : normalizeBaseUrl(import.meta.env.VITE_AUTH_URL || "http://localhost:3001");

/**
 * RAG API base URL. Production uses the Elysia `/rag-api` proxy on the API host.
 */
export const RAG_BASE = import.meta.env.DEV
  ? "/rag-api"
  : normalizeBaseUrl(import.meta.env.VITE_RAG_API_URL) || `${API_BASE}/rag-api`;

/**
 * Platform API base URL (integrations such as Google Drive).
 * Empty in Vite dev (proxied to platform-api).
 */
export const PLATFORM_BASE = import.meta.env.DEV
  ? ""
  : normalizeBaseUrl(import.meta.env.VITE_PLATFORM_API_URL);

/** Build an absolute platform API path from a relative route. */
export function platformUrl(path: string): string {
  const normalizedPath = path.startsWith("/") ? path : `/${path}`;
  return `${PLATFORM_BASE}${normalizedPath}`;
}

/** Build an absolute API path from a relative route. */
export function apiUrl(path: string): string {
  const normalizedPath = path.startsWith("/") ? path : `/${path}`;
  return `${API_BASE}${normalizedPath}`;
}

/** Build an absolute auth path from a relative route. */
export function authUrl(path: string): string {
  const normalizedPath = path.startsWith("/") ? path : `/${path}`;
  return `${AUTH_BASE}${normalizedPath}`;
}

/** Build an absolute RAG proxy path from a relative route. */
export function ragUrl(path: string): string {
  const normalizedPath = path.startsWith("/") ? path : `/${path}`;
  return `${RAG_BASE}${normalizedPath}`;
}
